import styled from 'styled-components'
import { Flex, Token, VStack } from '@revolut-internal/ui-kit'

export const AssistantPlaygroundContentWrapper = styled(VStack)`
  align-items: center;
  height: calc(100vh - 100px);
  gap: ${Token.space.s16};
`

export const ChatContentWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 0px;
  gap: ${Token.space.s16};
`
